import { Link } from 'react-router-dom';
import PageHeader from '../components/molecules/PageHeader';
import StudentDetailLayout_v2 from '../components/organisms/StudentDetailLayout_v2';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Skeleton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useStudentDetails } from '../hooks/studentDetails.hook';

const StudentDetail = () => {
  const { data, refetch, isLoading, canSeeDetails } = useStudentDetails();

  const RightSideLink = () => {
    return (
      <Link
        to={`/manage/students/edit/${data?.student_id}`}
        data-cy='edit-student-link'
        reloadDocument
      >
        Edit Student
      </Link>
    );
  };

  return (
    <div>
      <PageHeader
        testid='student-name-text'
        RightSideComponent={RightSideLink}
        backLink={
          <Link id='back-link-text' to='/manage/students' className='flex'>
            <ArrowBackIosNewIcon /> Back to Students
          </Link>
        }
      >
        {data && Object.keys(data).length ? (
          <>
            {data?.student_first_name} {data?.student_last_name}
          </>
        ) : (
          <Skeleton variant='text' />
        )}
      </PageHeader>

      {canSeeDetails ? (
        <StudentDetailLayout_v2 studentDetail={data} refetch={refetch} />
      ) : (
        <div className='text-center text-lg font-medium text-red-700'>
          This student does not exist, or you do not have permissions to access
          this page.
        </div>
      )}
      <div className='midSpacer'></div>
      <Backdrop
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </div>
  );
};

export default StudentDetail;
